import { type ReactNode } from 'react'
import { SearchInput } from '@opallabs/lapidary'
import * as styles from './styles'

export { selectors as calendarPageHeaderSelectors } from './styles'

export type CalendarPageHeaderSearch = Readonly<{
  /** What the box holds when it is drawn. Only the first value is read. */
  initialValue?: string
  /** Names the box for a screenreader. The magnifier carries no text. */
  labelText: string
  onSearch: (text: string) => void
  placeholder: string
  value?: string
}>

export type CalendarPageHeaderProps = Readonly<{
  /** The overflow menu, the page's calls to action and the avatar. */
  actions?: ReactNode
  /** The timescale tabs. */
  center?: ReactNode
  /** Absent draws no search box, for a host that searches somewhere else. */
  search?: CalendarPageHeaderSearch
  title: string
}>

/**
 * The row that names the calendar page, in every timescale.
 *
 * It holds nothing of its own beyond the title and the search box: what the
 * page can do, and which timescales it offers, are the host's business.
 */
export const CalendarPageHeader: React.FC<CalendarPageHeaderProps> = ({
  actions,
  center,
  search,
  title,
}) => (
  <div className={styles.selectors.root} css={styles.root}>
    <div css={styles.start}>
      <h1 className={styles.selectors.title} css={styles.title}>
        {title}
      </h1>
      {search && (
        <SearchInput
          collapsible={true}
          context={title}
          initialValue={search.initialValue}
          labelText={search.labelText}
          onSearch={search.onSearch}
          placeholder={search.placeholder}
          value={search.value}
        />
      )}
    </div>

    <div css={styles.center}>{center}</div>

    <div css={styles.end}>{actions}</div>
  </div>
)
CalendarPageHeader.displayName = 'Calendar: CalendarPageHeader'
